<template>
  <div class="notransltate">
    <div class="userInfo">
      <!-- userName -->
      <div class="mb10 infoBox">
        <label class="label toCapitalize">{{locale.name}}</label>
        <input type="text" class="input mt5" v-model="user.userName">
      </div>
      <!-- //userName -->
      <!-- userPhone -->
      <div class="mb10 infoBox telInfoBox">
        <label class="label toCapitalize">{{locale.telephone}}</label>
        <div v-show="openCountry" class="searchCountry">
          <input
            type="text"
            class="input"
            placeholder="country name or code"
            ref="searchChatCountryInput"
            v-model="searchCountry"
            @focus.stop
            @click.stop
            @keyup.enter="setSearchCountry" />
          <button type="button" class="btn btnPrimary btnSearch" @click.stop="setSearchCountry">
            {{locale.search}}
          </button>
        </div>
        <vue-tel-input
          class="telInput input mt5"
          ref="telInput"
          v-model="user.userPhone"
          :mode="'national'"
          :autoDefaultCountry="true"
          :preferredCountries="filteredCountry"
          :validCharactersOnly="true"
          @input="inputTel"
          @open="toggleCountry(true)"
          @close="toggleCountry(false)"></vue-tel-input>
      </div>
      <!-- //userPhone -->
      <!-- userEmail -->
      <div class="mb10 infoBox">
        <label class="label toCapitalize">{{locale.email}}</label>
        <input type="text" class="input mt5" v-model="user.userEmail">
      </div>
      <!-- //userEmail -->
    </div>
    <button type="button" class="btnTalk" @click="updateUserinfo">{{locale.save}}</button>
  </div>
</template>

<script>
import regExp from '@/common/regExp'

export default {
  props: [
    'locale',
    'lang',
    'user'
  ],
  computed: {
    filteredCountry () {
      const word = regExp.replaceAllEmpty(this.searchCountry).toLowerCase()
      const findCountry = this.countryList.filter(x => {
        const iso2 = regExp.replaceAllEmpty(x.iso2).toLowerCase().includes(word)
        const dialCode = regExp.replaceAllEmpty(`+${x.dialCode}`).toLowerCase().includes(word)
        const name = regExp.replaceAllEmpty(x.name).toLowerCase().includes(word)
        return word.length > 0 && (iso2 || dialCode || name)
      }).map(x => x.iso2)
      return findCountry
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.countryList = this.$refs.telInput ? this.$refs.telInput.allCountries : []
    })
  },
  data () {
    return {
      openCountry: false,
      searchCountry: '',
      countryList: [],
      validatePhone: {}
    }
  },
  methods: {
    toggleCountry (isOpen) {
      this.openCountry = isOpen
      if (isOpen) {
        const findInput = this.$refs.searchChatCountryInput
        if (findInput) {
          this.$nextTick(() => findInput.focus())
        }
      }
    },
    inputTel (number, telObj) {
      this.validatePhone = telObj
      this.user.userPhone = telObj.number
    },
    setSearchCountry () {
      const value = this.$refs.searchChatCountryInput.value
      this.searchCountry = value
    },
    updateUserinfo () {
      this.$emit('updateUserinfo')
    }
  }
}
</script>

<style lang="scss" scoped>
@media screen and (min-width: 768px) {
  .infoBox {
    position: relative;
    &.telInfoBox {
      z-index: 10;
    }
    .label {
      position: absolute;
      top: 0;
      left: 4px;
      margin-top: -0.5em;
      padding: 4px;
      font-size: 12px;
      color: $color-grey;
      border-radius: 3px;
      background-color: $color-white;
      z-index: 9;
    }
  }
}
</style>
